// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-confirm-raiting {
  padding: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
}
.modal-confirm-raiting .confirm-raiting-check {
  display: flex;
  justify-content: center;
}
.modal-confirm-raiting .btn-confirm-raiting {
  width: 50%;
}
.modal-confirm-raiting .container-confirm-raiting {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  text-align: center;
}
.modal-confirm-raiting .container-confirm-raiting .txt-confirm-raiting {
  font-size: 12px;
  font-family: Poppins;
  color: rgba(0, 0, 0, 0.76);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Modal/ModalConfirmRaiting.less"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAPA;EASQ,aAAA;EACA,uBAAA;AACR;AAXA;EAcQ,UAAA;AAAR;AAdA;EAkBQ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AADR;AArBA;EAyBY,eAAA;EACA,oBAAA;EACA,0BAAA;AADZ","sourcesContent":[".modal-confirm-raiting{\n    padding: 5%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 20px;\n\n    .confirm-raiting-check{\n        display: flex;\n        justify-content: center;\n    }\n\n    .btn-confirm-raiting{\n        width: 50%;\n    }\n    \n    .container-confirm-raiting{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 5px;\n        text-align: center;\n\n        .txt-confirm-raiting{\n            font-size: 12px;\n            font-family:Poppins;\n            color: rgba(0, 0, 0, 0.76);\n        }\n\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
